<template>

  <v-dialog v-model="dialog" persistent max-width="90%">
    <v-card>
      <v-card-title>
        <span class="headline">{{ modo == "editar" ? 'Editar ' : 'Crear ' }}{{ item_editando.id_trabajo?'Tratamiento':'Receta' }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" @keypress="handleEnter" v-model="valid">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6" class="custom-col">
                <!-- Nombre de la receta -->
                <v-text-field v-model="receta.name" :rules="[v => !!v || 'Nombre de la receta requerido']"
                  label="Nombre de la receta" required>
                </v-text-field>
              </v-col>
              <!-- Tipo de la receta -->
              <v-col cols="12" sm="6" class="custom-col">
                <v-select :items="tipos_de_tratamiento" item-text="name" item-value="id" label="Tipo de receta"
                  v-model="receta.id_tipo" :rules="[v => !!v || 'Tipo tratamiento requerido']">
                </v-select>
              </v-col>
            </v-row>
            <v-row v-if="!desdeEnlace">
                <v-col cols="12" sm="6" class="custom-col">
                  <v-text-field
                    v-model.number="receta.notificacion_tiempo"
                    label="Tiempo real último tramo (horas)"
                    type="number"
                    min="1"
                    :disabled="receta.notificar === 0"
                    hint="Ej: 1.50"
                    persistent-hint
                  />
                </v-col>

              <v-col cols="12" sm="6" class="custom-col">
                <v-switch
                  v-model="receta.notificar"
                  :true-value="1"
                  :false-value="0"
                  label="Activar notificaciones"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" class="custom-col">
                <div class="table-container">
                  <!-- Tabla con valores editables -->
                  <table class="tabla-valores custom-table">
                    <thead>
                      <tr>
                        <th colspan="7">
                          <h4>Valores para el tratamiento</h4>
                        </th>
                      </tr>
                      <tr>
                        <!-- <th style="width:5%; text-align:center;">Hora inicio</th> -->
                        <!-- <th style="width:5%; text-align:center;">Hora fin</th> -->
                      <!-- <th style="width:5%; text-align:center;">Duración parcial</th> -->
                      <th style="width:5%; text-align:center;">Duración (HH:MM:SS)</th>
                      <th style="width:5%; text-align:center;">Temperatura inicial (ºC)</th>
                      <th style="width:5%; text-align:center;">Temperatura objetivo (ºC)</th>
                      <th colspan="2" style="width:5%; text-align:center;">Tolerancia (ºC)</th>
                      <!-- <th style="width:5%; text-align:center;">Finalizar</th> -->
                      <th style="width:3%; text-align:center;">Acciones</th>

                    </tr>
                
                  </thead>
                  <tbody>
                    <tr v-for="(fila, index) in detalles_tabla" :key="index">
                      <td>
                        <!-- v-time-picker en una celda de la tabla -->
                        <!-- <v-text-field v-model="fila.hora_inicio" no-title
                        @input="updateTimeInicio(index, $event)"></v-text-field> -->
                        <v-text-field  style="text-align:center;"  @input="updateTimeInicioAndTimeFin(index, $event)" :rules="[timeRule]" v-model="fila.duracion" no-title></v-text-field>
                      </td>
                      <td>
                        <!-- v-time-picker en una celda de la tabla -->
                        <!-- <v-text-field v-model="fila.hora_fin" no-title
                        @input="updateTimeFin(index, $event)"> -->
                      <!-- </v-text-field> -->
                      <v-text-field  @input="updateTemperaturaInicial(index, $event)" v-model="fila.temperatura_inicial" :rules="[numericRule]" no-title></v-text-field>

                    </td>
                    <!-- <td>
                      {{ $diferencia_tiempos(fila.hora_fin, fila.hora_inicio) }}
                    </td> -->
                    <td>
                      <v-text-field  @input="updateTemperaturaObjetivo(index, $event)" v-model="fila.setpoint" :rules="[numericRule]" no-title></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="+" @input="updateToleranciaMax(index, $event)" v-model="fila.tolerancia_max" :rules="(fila.tolerancia_max  != null && fila.tolerancia_max.length > 0)?[numericRule]:[]" no-title></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="-"  @input="updateToleranciaMin(index, $event)" v-model="fila.tolerancia_min" :rules="(fila.tolerancia_min  != null && fila.tolerancia_min.length > 0)?[numericRule]:[]" no-title></v-text-field>
                    </td>
                    <!-- <td>
                      <v-btn :color="buttonColor(index)" @click="toggleFinalizar(index)">{{ texto_finalizar(index) }}</v-btn>
                    </td> -->
                    <td>
                      <v-btn text @click="deleteRow(index,fila)"><v-icon dark>mdi-delete</v-icon></v-btn>
                      
                    </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="custom-col">
              <componente-grafica :visible="true" :detalles="receta.detalles" class="full-height-component" ></componente-grafica>
            </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn color="success" block @click="agregarFila()"><v-icon>mdi-plus</v-icon> Nueva fila </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel">Cancelar</v-btn>
        <v-btn color="green darken-1" text :disabled="!valid" @click="submit">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
 
 
<script>
import { mapState, mapActions } from 'vuex'
import componenteGrafica from "@/components/ComponenteGrafica.vue";
export default {
  name: 'FormularioReceta',
  components:{
    componenteGrafica
  },

  data() {
    return {
      valid: false,
      dialog: true,
      detalles_tabla:[],
      receta: {
        id_receta: null,
        name: '',
        nombre_tipo_tratamiento: '',
        id_tipo: null,
        id_usuario: null,
        username: '',
        notificar: 1,               // NUEVO
        notificacion_tiempo: null,  // NUEVO (horas)
        detalles: [],
        detallesBorrados: [],
      },
      timeRule:
      v => /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(v) || 'Formato no válido', //comprueba que las horas sean validas
      numericRule: 
        v => /^[+-]?\d*\.?\d*$/.test(v) || 'Caracter no válido', //comprueba que las temperaturas sean validas
    };
  },


  computed: {
    ...mapState(['tipos_de_tratamiento', 'users']),

    // segmentos(){
    //     let seg = []
    //     let ejesX= this.receta.detalles.map(it=>it.hora_fin)
    //     let valores= this.receta.detalles.map(it=>it.setpoint)

    //     return {ejesX,valores}
    // }

  },
  props: {
    item_editando: {
      type: Object,
      default: () => ({
        name: '',
      })
    },
    modo: String,
    desdeEnlace: {     // NUEVO
      type: Boolean,
      default: false
    }
  },

  watch: {
    item_editando: {
      immediate:true,
      handler(newVal) {
        console.log("cambio");
        if (this.modo != '' && newVal.id_receta != this.receta.id_receta) {
          this.receta = Object.assign({}, newVal);
          // Campos de notificación
          // console.log('item:',newVal,'notificar:', newVal.notificar, 'notificacion_tiempo:', newVal.notificacion_tiempo,'this_receta:',this.receta);

          this.detalles_tabla = []
          this.receta.detallesBorrados = []
          let temperatura_inicial = 0
          this.receta.detalles.forEach((d, index) => {//preparamos los detalles que se van a mostrar en el formulario
            // console.log(d, index);
            if(index > 0){

              let detalle = {
                id_detalle_receta: d.id_detalle_receta,
                duracion: this.$diferencia_tiempos(d.hora_fin, d.hora_inicio),
                temperatura_inicial,
                setpoint: d.setpoint,
                tolerancia_max: d.tolerancia_max,
                tolerancia_min: d.tolerancia_min
              }
              this.detalles_tabla.push(detalle)
            }
            temperatura_inicial = d.setpoint
          })
          if (this.$refs.form) {
            this.$nextTick(() => {
              this.$refs.form.resetValidation();
            });
          }
        }

      }
    }
  },


  methods: {
    validateTimeFormat(inputStr) {
      var pattern = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
      return pattern.test(inputStr);
    },
    handleEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // Evita que el formulario se envíe al presionar Enter
        this.submit();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Enviar datos
        this.$emit('close', this.receta);

      }
    },
    cancel() {
      this.$emit('cancel');
    },
    deleteRow(index,fila){
      if(this.modo == 'editar'){
        this.receta.detallesBorrados.push(this.receta.detalles[index + 1])
      }
      // si es el primer elemento hay que modificar el setpoint de la primera fila de la receta
      if(index == 0 && this.detalles_tabla.length > 1){
        this.receta.detalles[0].setpoint = this.detalles_tabla[index + 1].temperatura_inicial
      }

      this.receta.detalles.splice(index + 1, 1);
      this.detalles_tabla.splice(index, 1);
      // si hay alguna fila despues, cambian su hora de inicio y de final
      if(this.receta.detalles.length > index + 1){ 
          for (let i = index + 1; i < this.receta.detalles.length; i++) {
            this.receta.detalles[i].hora_inicio = this.receta.detalles[i-1].hora_fin
            this.receta.detalles[i].hora_fin =  this.$suma_horas(this.detalles_tabla[i-1].duracion, this.receta.detalles[i].hora_inicio)
          }
        }
      
      // si se ha quedado vacia la tabla vaciamos tambien la de la receta
      if(this.detalles_tabla.length == 0){
        if(this.modo == 'editar'){
          this.receta.detallesBorrados.push(this.receta.detalles[0])
        }
        this.receta.detalles = []
      }
      // this.detalles_tabla = this.detalles_tabla.filter(e => e != fila)
    },
    agregarFila() {
      //Buscar si existe alguna fila y poner como hora de inicio,
      //la hora fin de la última fila. Si no existe file poner 00:00
      let nuevo =   {
        hora_inicio: '00:00:00',
        hora_fin: '00:00:00',
        duracion:'00:00:00',
        temperatura_inicial: 0,
        setpoint: 0,
        tolerancia_max: null,
        tolerancia_min: null,
        // finalizar: false
      }
      if (this.receta.detalles.length > 0) {
        const anterior = this.receta.detalles[this.receta.detalles.length-1];
        nuevo.hora_inicio = anterior.hora_fin
        nuevo.hora_fin = anterior.hora_fin
        nuevo.temperatura_inicial = anterior.setpoint
        nuevo.setpoint = anterior.setpoint
      }else{
        this.receta.detalles.push( { 
          hora_inicio: "00:00:00", 
          hora_fin: "00:00:00", 
          setpoint: 0, 
          tolerancia_max: null, 
          tolerancia_min: null 
      })
      }
      this.receta.detalles.push({
        hora_inicio:nuevo.hora_inicio,
        hora_fin:nuevo.hora_fin,
        setpoint:nuevo.setpoint,
        tolerancia_max:null,
        tolerancia_min:null
      });
      this.detalles_tabla.push(nuevo);

    },//fin agregar fila
    updateTimeInicioAndTimeFin(index,event){
      // if(this.validateTimeFormat(event)){
        this.receta.detalles[index+1].hora_fin = this.$suma_horas(event, this.receta.detalles[index+1].hora_inicio)
        if(this.receta.detalles.length > index +2){ // si hay alguna fila despues, cambian su hora de inicio y de final
          for (let i = index + 2; i < this.receta.detalles.length; i++) {
            this.receta.detalles[i].hora_inicio = this.receta.detalles[i-1].hora_fin
            this.receta.detalles[i].hora_fin =  this.$suma_horas(this.detalles_tabla[i-1].duracion, this.receta.detalles[i].hora_inicio)
          }
        }
      // }
    },
    updateTemperaturaInicial(index, event){
      if(index == 0){
        this.receta.detalles[0].setpoint = event
      }
    },
    updateTemperaturaObjetivo(index, event){
      this.receta.detalles[index+1].setpoint = event
    },
    updateToleranciaMax(index,event){
      this.receta.detalles[index+1].tolerancia_max = event
    },
    updateToleranciaMin(index,event){
      this.receta.detalles[index+1].tolerancia_min = event
    }
    // updateTimeFin(index,event){
    //   console.log(index,event)
    // },
    // buttonColor(index) {
    //   return this.receta.detalles[index].finalizar ? 'blue' : 'green'; // Cambia el color del botón dependiendo del valor de 'isBlue'
    // },
    // toggleFinalizar(index){
    //   this.receta.detalles[index].finalizar=!this.receta.detalles[index].finalizar;
    //   this.receta.detalles.splice();
    // },
    // texto_finalizar(index){
    //   return this.receta.detalles[index].finalizar ? "Terminar" : "Continuar";
    // }


  },
};
</script>
 

<style scoped>
.custom-col {
  padding-top: 0px;
  padding-bottom: 0px;
}
.tabla-valores {
  width: 100%; /* Ancho de la tabla */
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}

.tabla-valores th, .tabla-valores td {
  border: 1px solid #dddddd; /* Borde de las celdas */
  padding: 8px; /* Espaciado interno */
  text-align: center; /* Alineación del texto */
}

.tabla-valores th {
  background-color: #f2f2f2; /* Color de fondo para las cabeceras */
}

.fila-tabla:hover {
  background-color: #f0f0f0; /* Color de fondo al pasar el cursor */
}
.v-data-table .v-data-table__wrapper tbody tr:hover {
  background-color: #55d47f; /* Cambiar el color al pasar el cursor */
}
.table-container {
  overflow-x: auto;
}
.custom-table {
  width: auto;
  table-layout: auto;
}
</style>